import "./infoBlock.css";

const defaultProps = {
  id: "",
  header: "",
  image: "",
  imageAlt: "",
  textContent: "",
  CTA: "",
};

export default function InfoBlock(props = defaultProps) {
  function RenderInfoGraphic() {
    if (!props.image) return;
    return <img src={props.image} alt={props.imageAlt} />;
  }

  function RenderContent() {
    if (typeof props.textContent === "string") {
      return <p className="info-text-content">{props.textContent}</p>;
    }
    //most likely an array passed in
    if (Array.isArray(props.textContent)) {
      return (
        <ul>
          {props.textContent.map((item, i) => (
            <li key={`${props.id ?? "info-block-"}li-${i}`}>{item}</li>
          ))}
        </ul>
      );
    }
  }

  function RenderCTA() {
    return props.CTA ?? null;
  }

  return (
    <div id={props.id} className="info-block">
      {/* Graphic */}
      {RenderInfoGraphic()}

      {/* header */}
      <h3 className="info-header">{props.header}</h3>

      {/* Content */}
      <article className="info-block-content-section">{RenderContent()}</article>

      {/* CTA */}
      <div className="cta-section">{RenderCTA()}</div>
    </div>
  );
}
